import { UserAPI } from "../ApiStore/apiStore";

let initialState = {
    itemsUser: [],
    isFetchingUserItems: true,
}

const GET_USER_ITEMS = "GET-USER-ITEMS";
const TOGGLE_IS_DISPETCHER_USER = "TOGGLE-IS-DISPETCHER-USER"

const userPageReducer = (state = initialState, action) => {

    switch (action.type) {
        case GET_USER_ITEMS: {

            return {
                ...state,
                itemsUser: action.itemsUser
            }
        }
        case TOGGLE_IS_DISPETCHER_USER: {

            return {
                ...state,
                isFetchingUserItems: action.isFetchingUserItems
            }
        }
        default: {
            return state;
        }
    }

}

export const getUserItemsAC = (itemsUser) => {

    return {
        type: GET_USER_ITEMS, itemsUser
    }
}

export const setToggleDispetcherTag = (isFetchingUserItems) => {
    return {
        type: TOGGLE_IS_DISPETCHER_USER, isFetchingUserItems
    }
}

export const setUserItems = () => async (dispatch) => {

    dispatch(setToggleDispetcherTag(true));
    let data = await UserAPI.ItemUser();
    dispatch(getUserItemsAC(data));
    dispatch(setToggleDispetcherTag(false));

}

export default userPageReducer;
